import React from 'react';

import './Footer.scss';

const Footer = () => {
  return (
    <div className='footer'>© 2026 Swapnil Shah. All Rights Reserved.</div>
  )
}

export default Footer